export type CamLayoutItem = {
  end: number;
  start: number;
};

export type CamLayoutSlot = {
  lane: number;
  lanes: number;
};

export const computeLanes = <T extends CamLayoutItem>(items: T[]): Map<T, CamLayoutSlot> => {
  const slots = new Map<T, CamLayoutSlot>();
  const sorted = [...items].sort((a, b) => a.start - b.start || b.end - a.end);

  let cluster: T[] = [];
  let clusterEnd = -Infinity;

  const flush = () => {
    if (!cluster.length) {
      return;
    }
    const laneEnds: number[] = [];
    const assigned = cluster.map(item => {
      const lane = laneEnds.findIndex(end => end <= item.start);
      const index = lane === -1 ? laneEnds.length : lane;
      laneEnds[index] = item.end;
      return { item, lane: index };
    });
    assigned.forEach(({ item, lane }) => slots.set(item, { lane, lanes: laneEnds.length }));
    cluster = [];
    clusterEnd = -Infinity;
  };

  sorted.forEach(item => {
    if (cluster.length && item.start >= clusterEnd) {
      flush();
    }
    cluster.push(item);
    clusterEnd = Math.max(clusterEnd, item.end);
  });
  flush();

  return slots;
};
